import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event15 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    Shasthya Nirapotta: Health Scheme for Sanitation Workers
                  </h2>

                  

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                   WaterAid in collaboration with Waadaa.Insure and Chartered Life, introduced Shasthya Nirapotta Scheme (SNS), a health protection scheme for low-income people specially the sanitation workers to ease their struggles and triumphs. <br /><br /> This health protection initiative is designed to improve healthcare access and provide financial support in the event of the premium holder's death. This innovative scheme is also graciously supported by Government of Sweden, and Bill and Melinda Gates Foundation.
                   <br /><br /> SNS is transforming lives across Bangladesh, ensuring that no family suffers the devastating consequences of losing its breadearner due to unforeseeable health issues. This International Workers' Day, join the movement for change and help us to spread awareness about the importance of protecting the health and well-being of the working class and ensure a safer, healthier future for all.


                   <br /><br />
                   Video Link: <a
                      href="https://www.youtube.com/watch?v=TMYixGrmGN8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.youtube.com/watch?v=TMYixGrmGN8
                    </a>
                  </p>
                  
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event15;
